export const iconFontAwesomeSocialHeart = (
	<i className="fa-solid fa-heart"></i>
);
